import { render, staticRenderFns } from "./UserSettingCost.vue?vue&type=template&id=f6fa45c8&scoped=true&"
import script from "./UserSettingCost.vue?vue&type=script&lang=js&"
export * from "./UserSettingCost.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6fa45c8",
  null
  
)

export default component.exports